import { render } from "./IconMarketing.vue?vue&type=template&id=515a40d2"
import script from "./IconMarketing.vue?vue&type=script&lang=js"
export * from "./IconMarketing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__